import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from './styles';

const Header = () => {
  const classes = useStyles();
  return (
    <Box className={classes.header}>
      {/* <Typography variant="h1Large" component="h1">Welcome to</Typography> */}
      <Typography variant="h1Large" component="h1" style={{ color: '#7B5599' }}>
        Venture Investment Planning
      </Typography>
    </Box>
  );
};

export default Header;
